import React, { ReactNode, useEffect } from "react";
import { GrowthBook } from "@growthbook/growthbook";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import {
   autoAttributesPlugin,
   thirdPartyTrackingPlugin,
} from "@growthbook/growthbook/plugins";

interface GrowthBookProvidersProps {
   children: ReactNode;
}

const isBrowser = typeof window !== "undefined";

const growthbook = new GrowthBook({
   apiHost: process.env.GROWTHBOOK_API_HOST || "",
   clientKey: process.env.GROWTHBOOK_CLIENT_KEY || "",
   enableDevMode: process.env.NODE_ENV !== "production",
   plugins: isBrowser ? [
      autoAttributesPlugin(),
      thirdPartyTrackingPlugin({ trackers: ["ga4", "gtm"] }),
   ] : [],
});

export const GrowthBookProviders: React.FC<GrowthBookProvidersProps> = ({ children }) => {
   useEffect(() => {
      growthbook.init({ streaming: true }).catch((err) => {
         console.error("GrowthBook failed to initialize:", err);
      });
   }, []);

   useEffect(() => {
      let userId = localStorage.getItem("growthbook_user_id");
      if (!userId) {
         userId = crypto.randomUUID();
         localStorage.setItem("growthbook_user_id", userId);
      }
      growthbook.updateAttributes({ "user_id": userId });
   }, []);

   return (
      <GrowthBookProvider growthbook={growthbook}>
         {children}
      </GrowthBookProvider>
   );
};
